import {type ComponentProps} from 'react';
import {ChevronDownIcon} from '@heroicons/react/24/outline';
import {Button, Dropdown} from 'components';
import {classNames} from 'utils';

interface IButtonWithOptionsProps extends ComponentProps<typeof Button> {
  options: ComponentProps<typeof Dropdown>['items'];
}

const ButtonWithOptions = ({options, ...props}: IButtonWithOptionsProps) => {
  return (
    <div className="relative mr-9">
      <Dropdown
        items={options}
        containerClass={classNames(
          'absolute inset-0 -right-9 flex justify-end items-center duration-200',
          props.rounded ? 'rounded-full' : 'rounded-md',
          props.variant === 'alert' && 'bg-red-500 hover:bg-red-400',
          props.variant === 'secondary' && 'border border-primary dark:border-slate-400 hover:bg-slate-100 dark:hover:bg-slate-700',
          !props.variant && 'bg-primary border border-primary hover:brightness-120',
        )}
        button={
          <ChevronDownIcon
            className={classNames('size-8 p-2 cursor-pointer', props.variant === 'secondary' ? 'text-primary dark:text-darkText' : 'text-white')}
          />
        }
      />
      <div className="relative">
        <Button
          {...props}
          rounded={classNames(
            'border-r',
            props.variant === 'secondary' ? 'border-r-primary' : 'border-r-white',
            props.rounded ? 'rounded-l-full' : 'rounded-l-md',
          )}
        />
      </div>
    </div>
  );
};

export default ButtonWithOptions;
